import Circle_Write from '../../components/ExcerciseTypes/Circle_Write'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'
const json = {
	1: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P30-E1',
		audio: '',
		hideBtnFooter: true,
		// exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '1',
				title: 'Circle the words.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
       
            <div> <img style='width:22cm' src='img/FriendsPlus/Page30/E1/1.jpg' /> </div>
          `,
				answer: [''],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P30-E2',
		audio: '',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page30/E2/Key/E2answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		inputSize: 100,
		textAlign: 'center',
		maxLength: 30,
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '2',
				title: 'Now write.',
				color: '#234090',
			},
		],
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 24,
			height: 50,
			width: 280,
		},
		questions: [
			{
				title: `
       <div style='position:relative'>
       <img src='img/FriendsPlus/Page30/E2/1.jpg' />

        <div style=" position: absolute; top: 156px; left: 356px; ">#</div>
        <div style=" position: absolute; top: 156px; left: 734px; ">#</div>
        <div style=" position: absolute; top: 395px; left: 222px; ">#</div>
        <div style=" position: absolute; top: 395px; left: 587px; ">#</div>
     
      </div>
            
          `,
				answer: ['Vietnamese', 'P.E.', 'English', 'math'],
			},
		],
	},
	3: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P30-E3',
		audio: '',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page30/E3/Key/E3answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		inputSize: 100,
		textAlign: 'center',
		maxLength: 30,
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '3',
				title: ' Order the words.',
				color: '#234090',
			},
		],
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 26,
			height: 50,
			width: 300,
		},
		questions: [
			{
				title: `
       <div style='position:relative'>
       <img src='img/FriendsPlus/Page30/E3/1.jpg' />

        <div style=" position: absolute; top: 135px; left: 647px"><input id='0' width='400px'></input></div>
        <div style=" position: absolute; top: 200px; left: 733px"><input id='1' width='400px'></input></div>
        <div style=" position: absolute; top: 266px; left: 600px"><input id='2' width='450px'></input></div>
        <div style=" position: absolute; top: 331px; left: 614px"><input id='3' width='450px'></input></div>
     
      </div>
            
          `,
				answer: [
					'I have Vietnamese on Friday.',
					'Do you have art on Wednesday?',
					'I have P.E. on Thursday.',
					'When do you have music?',
				],
			},
		],
	},
}

export default json
